export const BUTTON_MODE = {
  TEXT: 'text',
  OUTLINED: 'outlined',
  OUTLINED_CHIP: 'outlined_chip',
  CONTAINED: 'contained',
  MENU: 'menu',
  TAB: 'tab',
};

export const BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ERROR: 'error',
  SUCCESS: 'success',
};

export const sizeMap = {
  s: {
    height: 32,
    fontSize: 14,
    padding: '6px 16px',
  },
  m: {
    height: 40,
    fontSize: 16,
    padding: '8px 22px',
  },
  l: {
    height: 48,
    fontSize: 18,
    padding: '10px 28px',
  },
  xl: {
    height: 52,
    fontSize: 18,
    padding: '12px 32px',
  },
};

